import React, { Dispatch, SetStateAction, useEffect, useState, JSX } from "react"
import { useUser } from "../Services"
import { LoginModal, ForgotPasswordModal, ResetPasswordModal, CreateUserModal, SiteListModal, WaitAnimation } from "../Components"
import { Pages, NavigationFunction as RootNavigation } from "../Navigation/root"
import { Navigate, useLocation, useNavigate } from "react-router"
import { RootPages } from "../Navigation/pages"
import { IS_CLOUD } from "../app"
import { colors } from "../Styles"
import { useSearchParams } from "react-router-dom"

// Modals on Login Page
/* eslint-disable */
enum Auth_States {
  Login,
  CreateUser,
  SiteList,
  ForgotPassword,
  ResetPassword,
  UserInformation,
  Loading
}
/* eslint-enable */

// Login Modal
function Login({ setNewState }: { setNewState: Dispatch<SetStateAction<Auth_States>> }): JSX.Element {
  const navigator = useNavigate()
  return (
    <LoginModal
      ifSuccess={() => setNewState(Auth_States.SiteList)}
      onClose={() => RootNavigation({ Navigator: navigator, navigation_page: RootPages.def })}
      onCreateUser={() => setNewState(Auth_States.CreateUser)}
      onResetPassword={() => setNewState(Auth_States.ForgotPassword)}
    />
  )
}

// Forgot Password Modal
function ForgotPassword({ setNewState }: { setNewState: Dispatch<SetStateAction<Auth_States>> }) {
  return (
    <ForgotPasswordModal
      ifSucces={() => setNewState(Auth_States.ResetPassword)}
      onGoBack={() => setNewState(Auth_States.Login)}
    />
  )
}

// Forgot Password Modal
function ResetPassword({ setNewState }: { setNewState: Dispatch<SetStateAction<Auth_States>> }) {
  return (
    <ResetPasswordModal
      ifSucces={() => setNewState(Auth_States.Login)}
    />
  )
}

// Create User Modal
function CreateUser({ setNewState }: { setNewState: Dispatch<SetStateAction<Auth_States>> }) {
  return (
    <CreateUserModal
      ifSuccess={() => setNewState(Auth_States.UserInformation)}
      onGoBack={() => setNewState(Auth_States.Login)}
    />
  )
}

// Choose Site Modal
function SiteList({ setNewState }: { setNewState: Dispatch<SetStateAction<Auth_States>> }) {
  const navigator = useNavigate()
  const location = useLocation()
  const selected = location.state?.selected
  const [searchParams] = useSearchParams()

  const navOrigin = searchParams.get('origin');
  return (
    <SiteListModal ifSuccess={(domain: string) => {
      if (IS_CLOUD) {
        setNewState(Auth_States.Loading);
        const tempLink = document.createElement('a');
        tempLink.href = `${window.location.origin}/${(selected === Pages.op_operations || navOrigin === '2') ? Pages.op_operations : Pages.kpi}?domain=${domain}`
        tempLink.rel = 'noreferrer';
        tempLink.click();
      } else {
        RootNavigation({ Navigator: navigator, navigation_page: (selected === Pages.op_operations || navOrigin === '2') ? Pages.op_operations : Pages.kpi, currentDomain: domain })
      }
    }
    } />
  )
}

// User Authentication
export default function Authentication_Path() {
  const [currentState, setCurState] = useState<Auth_States>(Auth_States.Login)
  const { userToken } = useUser()

  useEffect(() => {
    if (userToken) {
      setCurState(Auth_States.SiteList)
    }
    else setCurState(Auth_States.Login)
  }, [userToken])

  switch (currentState) {
    case Auth_States.Login:
      return <Login setNewState={setCurState} />
    case Auth_States.ForgotPassword:
      return <ForgotPassword setNewState={setCurState} />
    case Auth_States.ResetPassword:
      return <ResetPassword setNewState={setCurState} />
    case Auth_States.CreateUser:
      return <CreateUser setNewState={setCurState} />
    case Auth_States.SiteList:
      return <SiteList setNewState={setCurState} />
    case Auth_States.UserInformation: {
      return <Navigate to={Pages.userInformations} replace={true} />
    }
    case Auth_States.Loading: {
      return (
        <div style={{ display: "flex", justifyContent: "center", textAlign: "center", height: "100vh", alignItems: "center", color: colors.blueDarkPrimary }}>
          <WaitAnimation color={colors.greyLightTertiary} />
        </div>
      )
    }
    case undefined:
    default:
      return <></>
  }
}
